import styles from "./FeatureChangeLog.module.css";
import Icon from "@mdi/react";
import { mdiFormatListBulleted } from "@mdi/js";

// React
import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router";

// Tools
import Services from "tools/Services";

// Components

// Tools
import { beautifyDate, daysAgo } from "tools/dateHandlers";

export default function FeatureChangeLog(props) {
	const { id } = useParams();
	const [featureLogs, setFeatureLogs] = useState([]);

	useEffect(() => {
		loadFeatureLogs(id);
	}, [props.status]);

	const loadFeatureLogs = async (id) => {
		// GET
		let res = await Services.get("/Log/getFeatureLogs/" + id);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCES
		setFeatureLogs(res.data);
	};
	return (
		<>
			{featureLogs.length > 0 && (
				<div className={styles.container}>
					<h3 className={styles.title}>
						<Icon path={mdiFormatListBulleted} size={1} />
						Changes
					</h3>
					{featureLogs.map((l) => (
						<div className={styles.item} key={l.idFeatureLog}>
							{l.value}
							<div className={styles.date}>{beautifyDate(l.date)}</div>
						</div>
					))}
				</div>
			)}
		</>
	);
}
